import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { Button, TextField } from '@material-ui/core'
import { formStyles } from '../../components/Invoice/Steps/FormStyles'
import { handleNotificationAlert } from '../../utils/helpers'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined'
import LinkIcon from '@material-ui/icons/Link'

const InvoiceGetPublicLink = ({ currentData }) => {
  const intl = useIntl()
  const [copied, setCopied] = React.useState(false)
  const classes = formStyles()
  const handleCopyLink = () => {
    handleNotificationAlert({
      type: 'done',
      message: intl.formatMessage({ id: 'Invoice.Action.copy' }),
      color: 'success'
    }, 'success')

  }
  return (

    <div className={classes.formWrapper + ' ' + classes.getLinkWrapper}>

      <TextField
        fullWidth
        disabled={true}
        multiline={true}
        rows={3}
        margin="dense"
        type={'text'}
        variant="outlined"
        value={currentData?.publicUrl || ''}
        onClick={() => {
          if (!copied) {
            setCopied(true)
            handleCopyLink()
          }
        }}
      />

      <div className={classes.getLinkButtonsWrapper}>
        <CopyToClipboard text={currentData?.publicUrl || ''} onCopy={handleCopyLink}>
          <Button size={'large'} color={'primary'} variant={'contained'}><FileCopyOutlinedIcon/><FormattedMessage
            id='Invoice.Action.copy.text'/></Button>
        </CopyToClipboard>
        <Button size={'large'} color={'secondary'} variant={'contained'} href={currentData?.publicUrl}
                target={'_blank'}><LinkIcon/><FormattedMessage
          id='Invoice.Action.goToLink.text'/></Button>
      </div>

    </div>
  )
}

export default InvoiceGetPublicLink
